import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

type Props = {
  /** Called when the user confirms the deletion. */
  onConfirm: () => void | Promise<void>
  /** Name of the item, shown in the confirmation dialog. */
  itemLabel?: string
  disabled?: boolean
}

/**
 * A "Löschen" button that opens a "Möchten Sie das wirklich tun?" confirmation
 * dialog before invoking onConfirm. Uses a MUI dialog rather than
 * window.confirm (unavailable in the embedded UI).
 */
export const ConfirmDeleteButton = ({
  onConfirm,
  itemLabel,
  disabled,
}: Props) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        variant="outlined"
        color="error"
        startIcon={<DeleteOutlineIcon />}
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        Löschen
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Möchten Sie das wirklich tun?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {itemLabel ? `„${itemLabel}" ` : 'Dieser Eintrag '}
            wird archiviert und verschwindet aus der Liste.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Abbrechen</Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              // Close before awaiting: onConfirm may unmount this component.
              setOpen(false)
              void onConfirm()
            }}
          >
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
